// src/main.js
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router';
import App from './App.vue'

const app = createApp(App)

app.use(ElementPlus)
app.use(router) // 使用 router 实例
app.mount('#app')